var _circle, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRoundTickFillSuccess = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#3BB273"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1452 19.8495L46.106 18.8367C44.9651 17.7211 43.0959 17.7211 41.9514 18.8367L24.3069 36.0552L18.0459 29.9486C16.905 28.8342 15.0346 28.8342 13.8937 29.9497L12.8557 30.9614C11.7148 32.0758 11.7148 33.8996 12.8557 35.014L22.2247 44.1651C23.3668 45.2783 25.2361 45.2783 26.3782 44.1651L47.1452 23.9021C48.2849 22.7877 48.2849 20.9639 47.1452 19.8495Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoundTickFillSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/round_tick_fill_success.f2e6068b.svg";
export { ForwardRef as ReactComponent };